import React from 'react'
import LeftSection from './EventDetailsLeftSection'
import RightSection from './EventDetailsRightSection'

const EventDetails = ({ event, ticketTypes, addOns, tableTypes }) => (
  <div className="event-details-container">
    <LeftSection event={event} />
    <RightSection event={event} ticketTypes={ticketTypes} addOns={addOns} tableTypes={tableTypes} />
  </div>
)

export default EventDetails
